import React from "react";
import "./Signup.css";
import { AppModal } from "../Modals/TextAreaModal";
import { SignupForm } from "./SignupForm";

import { SignupInfo } from "./SignupInfo";

import { SignupCodeCheck } from "./SignupCodeCheck";

//Signup is wrapper, contains state
//SignupInfo displays the state information - has button that leads to SignupForm
//SignupForm takes input from user, how many tickets to buy, person info - returns information to Signup.js state
//Seater - recieves personinfo from Signup.js state, user selects seat. This is reserved for 10 minutes, tracked by Signup.
// If 10 minutes are up, user must be sent back to Seater if he has progressed but not completed signup
//SignupConfirm - user gets overview of seat number, price and persons, must hit confirm
//SignupComplete -Thank you for reserving screen. Email has been sent, seat has been tagged reserved

export class TestSignup extends React.Component {
  constructor(props) {
    super(props);

    //State storage - should be hooked up with mongoose

    //We use OnLoadPost to get latest stored DB post. Intended to use with cancel button.
    this.state = {
      title: "Påmelding",
      post:
        '<h2>Påmelding</h2>Høstlan 4. Oktober 12:00 til 7. Oktober 12:00 <br> <br>Billett uten mat: 450 kr <br> Billett med mat: 500 kr <br> <br> Forhåndsbestilling kan kun betales med Vipps <br><br> For deltakere under 16 år trenger vi <a href="http://www.gamerlan.no/samtykkeskjema.pdf">samtykkeskjema</a> <br> Levering av samtykkeskjema skjer ved oppmøte <br><br>Merk at matbillett må bestilles sammen med plassene<br> Du kan reservere for inntil 5 personer <br>',
      onLoadPost:
        '<h2>Påmelding</h2>  Høstlan 4. Oktober 12:00 til 7. Oktober 12:00 <br><br> Billett uten mat: 450 kr <br> Billett med mat: 500 kr <br> <br> Forhåndsbestilling kan kun betales med Vipps <br><br> For deltakere under 16 år trenger vi <a href="http://www.gamerlan.no/samtykkeskjema.pdf">samtykkeskjema</a> <br> Levering av samtykkeskjema skjer ved oppmøte <br><br> Merk at matbillett må bestilles sammen med plassene<br> Du kan reservere for inntil 5 personer <br><br>',
      signupClosedMessage:
        "<h2>Påmelding er stengt</h2> <br> <br> Påmelding er stengt. Mer informasjon kommer senere.",
      signupFullMessage:
        "<h2>Påmelding er stengt</h2> <br> <br> Påmelding er stengt for denne gang <br> Om du ikke fikk plass, ta kontakt med oss på Facebook, da noe kan åpne seg. <br>",

      priceNoFood: 450,
      priceWithFood: 500,

      signupOpen: true,
      signupConfirmed: false,
      tooYoung: false,
      showModal: false,

      //Navigation
      signupStart: false,
      signupCodeValidated: false,
      p1Email: "",
      guid: "",

      numPersons: 1,

      auth: false
    };

    //Bindings
    this.changePost = this.changePost.bind(this);
    this.cancelPost = this.cancelPost.bind(this);
    this.savePost = this.savePost.bind(this);
    this.modalPop = this.modalPop.bind(this);
    this.changeNumPersons = this.changeNumPersons.bind(this);
    this.setSignupStatus = this.setSignupStatus.bind(this);
    this.signupIsConfirmed = this.signupIsConfirmed.bind(this);
    this.setStartSignup = this.setStartSignup.bind(this);
    this.setP1Email = this.setP1Email.bind(this);
    this.setSignupCodeStatus = this.setSignupCodeStatus.bind(this);
  }

  //On mount we check if signup is open or closed
  componentWillMount() {
    if (this.state.signupOpen === false) {
      this.setState({ post: this.state.signupClosedMessage }); //We change the post
    }
  }

  changePost(newPost) {
    //Takes an event param, done automatically by eventhandler - see AppModal for handleChange
    this.setState({ post: newPost }); //Updates the state with new value
  }

  changeNumPersons(num) {
    //Takes an event param, done automatically by eventhandler - see AppModal for handleChange
    if (num > 0 && num < 6) {
      console.log(num);
      this.setState({ numPersons: num }); //Updates the state with new value
    }
  }

  //Event for modal cancel button, sets Post state back to onLoadPost
  cancelPost(cancel) {
    this.setState({ post: this.state.onLoadPost });
    this.setState({ showModal: false });
  }
  //Event for modal save button, will push to DB, needs logic implementation
  savePost(newPost) {
    //Implement logic for saving post and refreshing the content
    console.log("saved the post");
    this.setState({ onLoadPost: newPost });
  }

  //Signup wont be open all year, so we can toggle this
  setSignupStatus(status) {
    this.setState({ signupOpen: status });
  }

  //When the confirm-dialogue is pressed in SignupForm we change these states
  signupIsConfirmed(e, isTooYoung) {
    this.setState({ tooYoung: isTooYoung, signupConfirmed: true });
  }

  setStartSignup(value) {
    if (this.state.signupStart === true) {
      this.setState({ signupStart: false });
      this.setState({ signupCodeValidated: false });
      this.setState({ guid: "" });
    } else {
      this.setState({ signupStart: true });
    }
  }

  modalPop(e) {
    //Trigger App's modal component... Toggles showModal true or false
    if (this.state.showModal === false) {
      this.setState({ showModal: true });
    } else {
      this.setState({ showModal: false });
    }
  }

  setP1Email(email) {
    this.setState({ p1Email: email });
  }

  setSignupCodeStatus(guid) {
    this.setState({ signupCodeValidated: true });
    this.setState({ guid: guid });
  }

  render() {
    return (
      <div className="Signup">
        <div>
          {this.state.signupStart === false && (
            <SignupInfo
              post={this.state.post}
              setStartSignup={this.setStartSignup}
              signupStart={this.state.signupStart}
              signupOpen={this.state.signupOpen}
            />
          )}
          {this.state.signupStart === true &&
            this.state.signupCodeValidated === false && (
              <h3 className="CodeHeader">
                Fyll inn din epost, og skriv inn koden du mottar.
              </h3>
            )}
          {this.state.signupStart === true &&
            this.state.signupCodeValidated === false && (
              <SignupCodeCheck
                setP1Email={this.setP1Email}
                setSignupCodeStatus={this.setSignupCodeStatus}
              />
            )}

          {this.state.auth === true && (
            <button className="btn btn-info" onClick={this.modalPop}>
              {" "}
              Modal{" "}
            </button>
          )}
          {this.state.showModal === true && (
            <AppModal
              post={this.state.post}
              onLoadPost={this.state.onLoadPost}
              onChange={this.changePost}
              cancelPost={this.cancelPost}
              savePost={this.savePost}
              showModal={this.state.showModal}
            />
          )}
        </div>
        {this.state.signupConfirmed === false &&
          this.state.signupOpen === true &&
          this.state.signupStart === true &&
          this.state.signupCodeValidated && (
            <SignupForm
              guid={this.state.guid}
              p1Email={this.state.p1Email}
              setStartSignup={this.setStartSignup}
              priceNoFood={this.state.priceNoFood}
              priceWithFood={this.state.priceWithFood}
              signupIsConfirmed={this.signupIsConfirmed}
              numPersons={this.state.numPersons}
              changeNumPersons={this.changeNumPersons}
            />
          )}
      </div>
    );
  }
}

export default TestSignup;



// WEBPACK FOOTER //
// ./src/Components/Signup/TestSignup.js